import * as React from 'react';
import { t } from 'i18next';

import { UIHelper } from '../../utils/UIHelper';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';

export interface ImportDialogProps extends React.Props<ImportDialog> {
    newSceneCallback: () => void;
    importCallback: () => void;
    cancelCallback: () => void;
}

export class ImportDialog extends React.Component<ImportDialogProps, {}> {
    public render(): JSX.Element {
        return (
            <div className="dialog-page-resizer" onClick={this.cancleAction}>
                <div className="dialog-big-button" onClick={this.importAsNewScene}>{t('Create new drawing')}</div>
                <div className="dialog-big-button" onClick={this.importInScene}>{t('Import into existing drawing')}</div>
                <div className="dialog-big-button" onClick={this.cancleAction}>{t('Cancel')}</div>
            </div>
        );
    }

    protected importAsNewScene = (event: React.MouseEvent) => {
        UIHelper.stopEvent(event);
        ViewSettingsActions.closeMessage();
        this.props.newSceneCallback();
    };

    protected importInScene = (event: React.MouseEvent) => {
        UIHelper.stopEvent(event);
        ViewSettingsActions.closeMessage();
        this.props.importCallback();
    };

    protected cancleAction = (event: React.MouseEvent) => {
        UIHelper.stopEvent(event);
        ViewSettingsActions.closeMessage();
        this.props.cancelCallback();
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/dialog/ImportDialog.tsx